import { Box }            from '@chakra-ui/react';
import { Link }           from 'react-router-dom';
import PageContainer      from '@/components/pageContainer/PageContainer';
import ResetPasswordForm  from './forms/ResetPasswordForm';
import { Stack }          from '@chakra-ui/react';
import { Text }           from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import useTranslations    from '@/hooks/useTranslations';

const ResetPasswordPage = () => {
	const { t } = useTranslation();
	const { getNavigationTranslation } = useTranslations();
	
	return (
		<PageContainer type='public'>
			<Box
				display="flex"
				alignItems="center"
				justifyContent="center"
				height="100%"
			>
				 <Box
					height="100%"
					maxWidth="600px"
					display="flex"
					flexDirection="column"
					justifyContent="space-between"
					padding="50px"
					marginBottom="70px"
				>
					<Box
                        display="flex"
						alignItems="center"
						justifyContent="center"
						height="100%"
                    >
						<Stack gap="30px" >
							<Box
								display="flex"
								flexDirection="column"
								gap="10px"
								maxWidth={{ base: 400, lg: 500 }}
							>
								<Text 
									className="poppins-semibold" 
									fontSize={{ base: 28, lg: 36 }}
								>
									{t('pages.resetPassword.label')}
								</Text>
								<Text fontSize="16px">{t('pages.resetPassword.mainText')}</Text>
							</Box>
							<ResetPasswordForm />
						</Stack>
					</Box>
					<Box
						display="flex"
						alignItems="center"
						justifyContent="center"
						flexWrap="wrap"
						paddingBottom="40px"
						paddingTop="40px"
					>
						<Text>
							{t('pages.registration.form.alreadyRegistered')}
						</Text>&nbsp;
						<Link 
							to={getNavigationTranslation('login', 'path')}
						>
							<Text 
								textDecoration="underline"
								fontWeight={600}
							>
								{t('pages.registration.form.login')}
							</Text>
						</Link>
				</Box>
					
				</Box>
			</Box>
		</PageContainer>
	);
};

export default ResetPasswordPage;